import Lang from 'lang.js';
import languageJson from '../lang.json';

export default new Lang({
  messages: languageJson,
  locale: 'nl',
  fallback: 'en',
});
